import { Controller } from "@hotwired/stimulus"

// Toggle a lazy turbo-frame open/closed (e.g. « Ajouter un produit » on company products).
export default class extends Controller {
  static targets = ["frame", "trigger", "close"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.onFrameLoad = this.syncFromFrame.bind(this)
    this.frameTarget.addEventListener("turbo:frame-load", this.onFrameLoad)
    this.syncFromFrame()
  }

  disconnect() {
    this.frameTarget.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  toggle(event) {
    if (this.openValue && this.frameHasContent()) {
      event.preventDefault()
      this.close()
      return
    }
    // Ouverture : le déclencheur bascule dès le clic, sans attendre le chargement de la frame.
    this.setExpanded(true)
  }

  close(event) {
    event?.preventDefault()
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = ""
    this.openValue = false
    this.updateChrome()
  }

  syncFromFrame() {
    this.openValue = this.frameHasContent()
    this.updateChrome()
  }

  frameHasContent() {
    return this.frameTarget.innerHTML.trim().length > 0
  }

  updateChrome() {
    if (this.hasCloseTarget) {
      this.closeTarget.classList.toggle("d-none", !this.openValue)
    }
    this.setExpanded(this.openValue)
  }

  // `aria-expanded` sur le déclencheur : état lu par les lecteurs d'écran et par le CSS
  // (le « + » des cartes produits pivote en croix).
  setExpanded(expanded) {
    this.triggerTargets.forEach((trigger) => trigger.setAttribute("aria-expanded", String(expanded)))
  }
}
